import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { VehicleSubModelModel, ListItem, DynamicObject1, ManufacturerModel, VehicleModelModel, SubModelWithDegem } from '../models/superbit-api-models';
import { GeneralDataModel } from '../models/GeneralDataModel';
import '../assets/css/_simple-popup.css'
import './_VehicleDetails.css'
import { GovData1, GovData2, ManulApiModel } from '../models/ManulApiModel'
import exampleIcon from '../assets/images/license2.webp';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import { SimulatorModel, } from '../models/SimulatorModel'


type Props = {
    tozeretCd?: number;
    degemCd?: number;
    year:number;
    manufacturerId: string;
    vehicleModelId: string;
    vehicleSubModelId: string;
    modelCode: string;
    ClosePopup: any;
    GetVehicleSubmodelId: any
};

type State = {
    manufacturerId: string;
    vehicleModelId: string;
    vehicleSubModelId: string;
    modelCode: string;
};

const VehicleDetails = (props: Props) => {
    const prevProps = useRef(props);

    const emptyGuid = "00000000-0000-0000-0000-000000000000";
    const generalModel: GeneralDataModel = new GeneralDataModel();

    const [vehicleSubmodel, setVehicleSubModelModel] = useState<VehicleSubModelModel | null>(null);
    const [manufactures, setManufactures] = useState<ListItem[]>([]);
    const [vehicleModels, setVehicleModels] = useState<ListItem[]>([]);
    const [vehicleSubModels, setVehicleSubModels] = useState<ListItem[]>([]);
    const [manufacturerText, setManufacturerText] = useState<string | undefined>(undefined);
    const [manufacturerId, setManufacturerId] = useState<string | undefined>(undefined);
    const [vehicleModelText, setVehicleModelText] = useState<string | undefined>(undefined);
    const [vehicleModelId, setVehicleModelId] = useState<string | undefined>(undefined);
    const [vehicleSubModelText, setVehicleSubModelText] = useState<string | undefined>(undefined);
    const [vehicleSubModelId, setVehicleSubModelId] = useState<string | undefined>(undefined);
    const [modelCode, setModelCode] = useState<string | undefined>(undefined);
    const [tozeretCd, setTozeretCd] = useState<number | undefined>(undefined);
    const [degemCd, setDegemCd] = useState<number | undefined>(undefined);
    const [loadGovData, setLoadGovData] = useState<boolean>(false);
    const [govError, setGovError] = useState<boolean>(false);

    const [createManufacturerMode, setCreateManufacturerMode] = useState<boolean>(false);
    const [createModelMode, setCreateModelMode] = useState<boolean>(false);
    const [createSubModelMode, setCreateSubModelMode] = useState<boolean>(false);
    const [updateSubModelMode, setUpdateSubModelMode] = useState<boolean>(false);
    const [modelErr, setModelErr] = useState<boolean>(false);
    const [submodelErr, setSubmodelErr] = useState<boolean>(false);

    const [showIcon, setShowIcon] = useState<boolean>(true);
    const [showImg, setShowImg] = useState<boolean>(false);

    useEffect(() => {
        console.log('!!!!!!!!!!!!!!!!!!!!!!!!VehicleDetails useEffect!!!!!!!!!!!!!!!!!!!!!!');
        load();
        init();
    }, []);

    const onManufacturerSelect = async (id: string | undefined) => {
        if (id) {
            let data = await generalModel.getVehicleModels(id);
            const models = data.filter((i: any) => i.text !== null);
            models.sort((a: any, b: any) => (a.text > b.text) ? 1 : -1);
            setVehicleModels(models);
        }
    }

    const onModelSelect = async (id: string) => {
        if (id) {
            let data = await generalModel.getVehicleSubModels(id);
            const models = data.filter((i: any) => i.text !== null);
            models.sort((a: any, b: any) => (a.text > b.text) ? 1 : -1);
            setVehicleSubModels(models);
        }
    }

    const GetVehicleSubmodelId = async () => {
        props.GetVehicleSubmodelId(vehicleSubModelId);
        closePopup();
    }

    const onSubmodelSelect = async (id: string) => {

        if (id) {
            let data = await generalModel.getVehicleInfoGetVehicleSubModelsById(id);
            setModelCode(data.modelCode);
        }
    }

    const ShowGovDetails = async () => {

        setLoadGovData(true);
    }

    const GetGovDetails = async () => {

        if (tozeretCd && degemCd) {
            getVehicleData();
            setLoadGovData(false);
        }

        //
    }


    const iconClick = async () => {
        setShowIcon(false);
        setShowImg(true);
        //
    }
    const imgClick = async () => {
        setShowIcon(true);
        setShowImg(false);
    }






    const isValidGuid = (guid: string): boolean => {
        const guidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
        return guidRegex.test(guid);
    }


    const onManufacturerChange = (e: any) => {
        const search = e.target.value;
        SelectManufacturer(search);


    }

    const SelectManufacturer = async (element: string | undefined) => {
        await setManufacturerText(element);
        const manufacturer = manufactures.filter((e: ListItem) => e.text == element);
        if (manufacturer && manufacturer.length > 0) {
            var manId = manufacturer[0].value
            setManufacturerId(manufacturer[0].value);
            onManufacturerSelect((manufacturer[0] as any).value);
        }

    }


    const onManufacturerPress = (e: any) => {
        if (e.key === 'Enter') {
            //find model
            const model = manufactures.filter((e: ListItem) => e.text == manufacturerText);
            if (model && model.length > 0) {
                setManufacturerId(model[0].value);
                onManufacturerPress((model[0] as any).value);
            }
            else {
                setCreateManufacturerMode(true);
            }


        }
        else {
            setCreateManufacturerMode(false);
        }
    }

    const onModelPress = (e: any) => {
        if (e.key === 'Enter') {
            const model = vehicleModels.filter((e: ListItem) => e.text == vehicleModelText);
            if (model && model.length > 0) {
                setVehicleModelId(model[0].value);
                onModelSelect((model[0] as any).value);
            }
            else {
                setCreateModelMode(true);
            }

        }
        else {
            setCreateModelMode(false);
        }
    }

    const onSubmodelPress = async (e: any) => {
        if (e.key === 'Enter') {
            const model = vehicleSubModels.filter((e: ListItem) => e.text == vehicleSubModelText);
            if (model && model.length > 0) {
                setVehicleSubModelId(model[0].value);
                if (model[0].value) {
                    var vehicleData = await generalModel.getVehicleInfoGetVehicleSubModelsById(model[0].value);
                    setModelCode(vehicleData.modelCode);

                }
                setUpdateSubModelMode(true);
                setCreateSubModelMode(false);
            }
            else {
                setCreateSubModelMode(true);
                setUpdateSubModelMode(false);

            }



        }
        else {
            setCreateSubModelMode(false);
            setUpdateSubModelMode(false);

        }
    }

    const onCreateManufacturerClick = async (e: any) => {
        var manufacturer = new ManufacturerModel();
        manufacturer.name = manufacturerText;
        if (manufacturerId)
            manufacturer.id = manufacturerId;
        await generalModel.vehicleInfoCreateManufacturer(manufacturer);
        setCreateManufacturerMode(false);

        const _manufactures = await generalModel.getVehicleManufaucters();
        await setManufactures(_manufactures);

        setManufacturerText(manufacturerText);
        const newEl = _manufactures.filter((e: ListItem) => e.text == manufacturerText);
        if (newEl && newEl.length > 0) {
            setManufacturerId(newEl[0].value);
            onManufacturerSelect((newEl[0] as any).value);
        }


    }


    const onCreateModelClick = async (e: any) => {

        if (!manufacturerId) {
            setModelErr(true);
            return;
        }
        setModelErr(false);
        var model = new VehicleModelModel();
        model.name = vehicleModelText;
        model.manufacturerId = manufacturerId;
        if (vehicleModelId)
            model.id = vehicleModelId;


        await generalModel.vehicleInfoCreateVehicleModel(model);
        setCreateModelMode(false);

        const _models = await generalModel.getVehicleModels(manufacturerId);
        await setVehicleModels(_models);

        setVehicleModelText(vehicleModelText);
        const newEl = _models.filter((e: ListItem) => e.text == vehicleModelText);
        if (newEl && newEl.length > 0) {
            setVehicleModelId(newEl[0].value);
            onModelSelect((newEl[0] as any).value);
        }


    }

    const onCreateSubModelClick = async (e: any) => {

        if (!vehicleModelId) {
            setSubmodelErr(true);
            return;
        }
        setSubmodelErr(false);

        var model = new SubModelWithDegem();
        model.name = vehicleSubModelText;
        model.vehicleModelId = vehicleModelId;
        model.modelCode = modelCode;
        model.tozeretCd = props.tozeretCd;
        model.degemCd = props.degemCd;
        var data = await generalModel.vehicleInfoCreateVehicleSubModel(model);
        setVehicleSubModelId(data.id);
        setUpdateSubModelMode(false);
        setCreateSubModelMode(false);

        //closePopup();
    }


    const onUpdateSubModelClick = async (e: any) => {
        if (!vehicleModelId) {
            setSubmodelErr(true);
            return;
        }
        setSubmodelErr(false);
        var model = new VehicleSubModelModel();
        model.name = vehicleSubModelText;
        model.vehicleModelId = vehicleModelId;
        model.modelCode = modelCode;
        model.id = vehicleSubModelId
        await generalModel.vehicleInfoCreateVehicleSubModel(model);
        setUpdateSubModelMode(false);
        setCreateSubModelMode(false);

        //closePopup();
    }



    const closePopup = () => {
        props.ClosePopup();
        console.log('closePopup')
    }

    const onModelChange = (e: any) => {
        const search = e.target.value;
        SelectModel(search);
    }

    const SelectModel = async (element: string | undefined) => {
        const model = vehicleModels.filter((e: ListItem) => e.text == element);
        if (model && model.length > 0) {
            var manId = model[0].value;
            setVehicleModelId(model[0].value);
            onModelSelect((model[0] as any).value);
        }
        else{
            setCreateModelMode(true);
        }
        await setVehicleModelText(element);
        

    }

    const onSubModelChange = (e: any) => {
        const search = e.target.value;
        SelectSubmodel(search);
    }

    const SelectSubmodel = async (element: string | undefined) => {

        await setVehicleSubModelText(element);
        const submodel = vehicleSubModels.filter((e: ListItem) => e.text == element);
        if (submodel && submodel.length > 0) {
            var id = submodel[0].value
            if (id) {
                await setVehicleSubModelId(id);
                onSubmodelSelect(id);

            }

            setUpdateSubModelMode(true);
            setCreateSubModelMode(false);
        }
        else {
            setUpdateSubModelMode(false);
            setCreateSubModelMode(true);
        }

    }

    const onModelCodeChange = async (e: any) => {
        const search = e.target.value;
        await setModelCode(search);

        if (search) {
            let data = await generalModel.getVehicleInfoGetVehicleSubModelsByModelCode(search);
            if (data) {
                setVehicleSubModelId(data.id);
                setVehicleSubModelText(data.name);

                setManufacturerId(data.vehicleModel && data.vehicleModel.manufacturer ? data.vehicleModel.manufacturer.id : "");
                setManufacturerText(data.vehicleModel && data.vehicleModel.manufacturer ? data.vehicleModel.manufacturer.name : "");

                setVehicleModelId(data.vehicleModel ? data.vehicleModel.id : "");
                setVehicleModelText(data.vehicleModel ? data.vehicleModel.name : "");

                
            }
        }

        if (vehicleSubModelId != null) {
            setCreateSubModelMode(false);
            setUpdateSubModelMode(false);
        }
        else {
            if (vehicleSubModelText && vehicleSubModelText.length > 0) {
                setCreateSubModelMode(true);
                setUpdateSubModelMode(false);
            }
        }
    }

    const clearAllValues = () => {

        if (manufacturerId == undefined || manufacturerId == "") {
            setManufacturerText(undefined);
            setCreateManufacturerMode(false);
        }
        if (vehicleModelId == undefined || vehicleModelId == "") {
            setVehicleModelText(undefined);
            setCreateModelMode(false);
        }
        if (vehicleSubModelId == undefined || vehicleSubModelId == "") {
            setVehicleSubModelText(undefined);
            setCreateSubModelMode(false);
            setUpdateSubModelMode(false);
        }

        setTozeretCd(undefined);
        setDegemCd(undefined);
        setLoadGovData(false);


    }
    const clearValue = (name: string) => {

        switch (name) {
            case 'manufacturerId':
                setManufacturerId(undefined);
                setManufacturerText(undefined);
                // setVehicleModelId(undefined);
                // setVehicleModelText(undefined);
                // setVehicleSubModelId(undefined);
                // setVehicleSubModelText(undefined);
                // setModelCode(undefined);
                // setUpdateSubModelMode(false);
                // setCreateSubModelMode(false);
                break;
            case 'vehicleModelId':
                setVehicleModelId(undefined);
                setVehicleModelText(undefined);
                setCreateModelMode(false);
                // setVehicleSubModelId(undefined);
                // setVehicleSubModelText(undefined);
                // setUpdateSubModelMode(false);
                // setCreateSubModelMode(false);
                break;
            case 'vehicleSubModelId':
                setVehicleSubModelId(undefined);
                setVehicleSubModelText(undefined);
                setUpdateSubModelMode(false);
                setCreateSubModelMode(false);
                break;
            case 'modelCode':
                setModelCode(undefined);
                break;
            default:
                break;
        }
    }

    useEffect(() => {
        if (prevProps.current !== props) {
            // Only run init if the props have changed from outside
            init();
        }
        prevProps.current = props; // Update previous props to current after the check
    }, [props]);


    const load = async () => {
        const manufactures = await generalModel.getVehicleManufaucters();
        const vehicleModels = await generalModel.getVehicleModels(undefined);
        const vehicleSubModels = await generalModel.getVehicleSubModels(undefined);
        await setManufactures(manufactures);
        await setVehicleModels(vehicleModels);
        await setVehicleSubModels(vehicleSubModels);

        

    }

    const init = async () => {

        await setManufacturerId(props.manufacturerId);
        await setVehicleModelId(props.vehicleModelId);
        await setVehicleSubModelId(props.vehicleSubModelId);
        await setModelCode(props.modelCode);

        if (props.vehicleSubModelId != null && props.vehicleSubModelId != emptyGuid && props.vehicleSubModelId.length > 0) {
            //if (vehicleSubModelId != null && vehicleSubModelId != emptyGuid && vehicleSubModelId.length > 0) {
            setVehicleSubModelId(props.vehicleSubModelId);
            var data = await new SimulatorModel().getVehicleDetails(props.vehicleSubModelId);
            setManufacturerId(data.manufacturer.val);
            setManufacturerText(data.manufacturer.label);
            setCreateManufacturerMode(false);

            setVehicleModelId(data.vehicleModel.val);
            setVehicleModelText(data.vehicleModel.label);
            setCreateModelMode(false);

            setVehicleSubModelText(data.vehicleSubModel.label);
            setCreateSubModelMode(false);
        }

        else {
            if (props.tozeretCd != undefined && props.tozeretCd > 0 && props.degemCd != undefined && props.degemCd > 0) {
                await setTozeretCd(props.tozeretCd);
                await setDegemCd(props.degemCd);

                var data2 = await new ManulApiModel().GetGovData4(props.tozeretCd + "", props.degemCd + "",props.year);

                if (data2 && data2.degem_cd != undefined) {
                    const newEl = manufactures.filter((e: ListItem) => e.text == data2.tozar);
                    if (newEl && newEl.length > 0) {
                        setManufacturerText(data2.tozar);
                        setManufacturerId(newEl[0].value);
                        await onManufacturerSelect(newEl[0].value);

                        const model = vehicleModels.filter((e: ListItem) => e.text == data2.kinuy_mishari);
                        if (model && model.length > 0) {
                            setVehicleModelText(data2.kinuy_mishari);
                            setVehicleModelId(model[0].value);
                            await onModelSelect((model[0] as any).value);

                            const subModel = vehicleSubModels.filter((e: ListItem) => e.text == data2.merkav);
                            if (subModel && subModel.length > 0) {
                                setVehicleSubModelText(`${data2.ramat_gimur} ${data2.hanaa_nm} (${data2.nefah_manoa}) ${data2.technologiat_hanaa_nm} ${data2.merkav}`);
                                setVehicleSubModelId(subModel[0].value);
                                if (subModel[0].value) {
                                    var vehicleData = await generalModel.getVehicleInfoGetVehicleSubModelsById(subModel[0].value);
                                    setModelCode(vehicleData.modelCode);

                                }
                                setUpdateSubModelMode(true);
                                setCreateSubModelMode(false);
                            }
                            else {
                                setVehicleSubModelText(`${data2.ramat_gimur} ${data2.hanaa_nm} (${data2.nefah_manoa}) ${data2.technologiat_hanaa_nm} ${data2.merkav}`);
                                setCreateSubModelMode(true);
                                setUpdateSubModelMode(false);

                            }
                        }
                        else {

                            setVehicleModelText(data2.kinuy_mishari);
                            setCreateModelMode(true);

                            setVehicleSubModelText(`${data2.ramat_gimur} ${data2.hanaa_nm} (${data2.nefah_manoa}) ${data2.technologiat_hanaa_nm} ${data2.merkav}`);
                            setCreateSubModelMode(true);
                            setUpdateSubModelMode(false);
                        }




                    }
                    else {
                        setManufacturerText(data2.tozar);
                        setCreateManufacturerMode(true);

                        setVehicleModelText(data2.kinuy_mishari);
                        setCreateModelMode(true);

                        setVehicleSubModelText(`${data2.ramat_gimur} ${data2.hanaa_nm} (${data2.nefah_manoa}) ${data2.technologiat_hanaa_nm} ${data2.merkav}`);
                        setUpdateSubModelMode(false);
                        setCreateSubModelMode(true);

                    }
                }
                else {
                    setGovError(true);
                }

            }
            else {
                clearAllValues();
            }
        }
        if (props.modelCode) {
            setModelCode(props.modelCode);
        }
    };

    const getVehicleData = async () => {

        setGovError(false);
        var data2 = await new ManulApiModel().GetGovData3(tozeretCd + "", degemCd + "");
        if (data2 && data2.degem_cd != undefined) {
            const newEl = manufactures.filter((e: ListItem) => e.text == data2.tozar);
            if (newEl && newEl.length > 0) {
                setManufacturerText(data2.tozar);
                setManufacturerId(newEl[0].value);
                if (manufacturerId)
                    await onManufacturerSelect(manufacturerId);

                const model = vehicleModels.filter((e: ListItem) => e.text == data2.kinuy_mishari);
                if (model && model.length > 0) {
                    setVehicleModelText(data2.kinuy_mishari);
                    setVehicleModelId(model[0].value);
                    await onModelSelect((model[0] as any).value);

                    const subModel = vehicleSubModels.filter((e: ListItem) => e.text == data2.merkav);
                    if (subModel && subModel.length > 0) {
                        setVehicleSubModelText(`${data2.ramat_gimur} ${data2.hanaa_nm} (${data2.nefah_manoa}) ${data2.technologiat_hanaa_nm} ${data2.merkav}`);
                        setVehicleSubModelId(subModel[0].value);
                        if (subModel[0].value) {
                            var vehicleData = await generalModel.getVehicleInfoGetVehicleSubModelsById(subModel[0].value);
                            setModelCode(vehicleData.modelCode);

                        }
                        setUpdateSubModelMode(true);
                        setCreateSubModelMode(false);
                    }
                    else {
                        setVehicleSubModelText(`${data2.ramat_gimur} ${data2.hanaa_nm} (${data2.nefah_manoa}) ${data2.technologiat_hanaa_nm} ${data2.merkav}`);
                        setCreateSubModelMode(true);
                        setUpdateSubModelMode(false);

                    }
                }
                else {
                    setVehicleModelText(data2.kinuy_mishari);
                    setCreateModelMode(true);

                    setVehicleSubModelText(`${data2.ramat_gimur} ${data2.hanaa_nm} (${data2.nefah_manoa}) ${data2.technologiat_hanaa_nm} ${data2.merkav}`);
                    setCreateSubModelMode(true);
                    setUpdateSubModelMode(false);
                }




            }
            else {
                setManufacturerText(data2.tozar);
                setCreateManufacturerMode(true);

                setVehicleModelText(data2.kinuy_mishari);
                setCreateModelMode(true);

                setVehicleSubModelText(`${data2.ramat_gimur} ${data2.hanaa_nm} (${data2.nefah_manoa}) ${data2.technologiat_hanaa_nm} ${data2.merkav}`);
                setUpdateSubModelMode(false);
                setCreateSubModelMode(true);

            }


        }
        else {
            setGovError(true);
        }


    };



    return (
        <div className="popup-wrapper">
            <section className="popup-window new-subscriber rtl">
                <div className="close-icon pointer" onClick={(e: any) => closePopup()}></div>

                <div className="popup-content">
                    <div className="popup-header">
                        <div className="popup-title">
                            דגמי רכב
                        </div>
                    </div>
                    <div className="popup-body">
                        <div className="filter-row flex-centered flex-space-between">
                            <div className='search-input-div'>
                                <div className="search-input">
                                    <div className="label">
                                        יצרן
                                    </div>
                                    <div className="filter-input">
                                        <input type='text'
                                            list="manufacturer_list"
                                            onChange={(e: any) => onManufacturerChange(e)}
                                            onKeyDown={(e: any) => onManufacturerPress(e)}
                                            value={manufacturerText == null ? "" : manufacturerText}
                                        />
                                        <datalist id="manufacturer_list">
                                            {manufactures.map((o: any, i) => <option key={i} value={o.text}>{o.text}</option>)}
                                        </datalist>
                                        <div className={`icon x-clear pointer ${!manufacturerText ? 'hide' : ''}`} onClick={() => clearValue('manufacturerId')}></div>
                                    </div>

                                </div>
                                <div className={createManufacturerMode ? "search-input-btn" : "hide"}
                                    onClick={(e: any) => onCreateManufacturerClick(e)}
                                >ליצור {manufacturerText}?</div>
                            </div>
                            <div className='search-input-div'>
                                <div className="search-input">
                                    <div className="label">
                                        דגם
                                    </div>
                                    <div className="filter-input">
                                        <input type='text'
                                            list="model_list"
                                            onChange={(e: any) => onModelChange(e)}
                                            onKeyDown={(e: any) => onModelPress(e)}
                                            value={vehicleModelText != null ? vehicleModelText : ""}
                                        />
                                        <datalist id="model_list">
                                            {vehicleModels && vehicleModels.map((o: any, i) => <option key={i} value={o.text}>{o.text}</option>)}
                                        </datalist>


                                        <div className={`icon x-clear pointer ${!vehicleModelText ? 'hide' : ''}`} onClick={() => clearValue('vehicleModelId')}></div>
                                    </div>

                                </div>
                                <div className={createModelMode ? "search-input-btn" : "hide"}
                                    onClick={(e: any) => onCreateModelClick(e)}
                                >ליצור {vehicleModelText}?</div>
                                <div className={modelErr ? "error-message" : "hide"}>חסר נתוני יצרן</div>
                            </div>
                            <div className='search-input-div'>
                                <div className="search-input">
                                    <div className="label">
                                        תת דגם
                                    </div>
                                    <div className="filter-input">
                                        <input type='text'
                                            list="submodel_list"
                                            onChange={(e: any) => onSubModelChange(e)}
                                            onKeyDown={(e: any) => onSubmodelPress(e)}
                                            value={vehicleSubModelText != null ? vehicleSubModelText : ""}
                                        />
                                        <datalist id="submodel_list">
                                            {vehicleSubModels && vehicleSubModels.map((o: any, i) => <option key={i} value={o.text}>{o.text}</option>)}
                                        </datalist>


                                        <div className={`icon x-clear pointer ${!vehicleSubModelText || vehicleSubModelText.length == 0 ? 'hide' : ''}`} onClick={() => clearValue('vehicleSubModelId')}></div>
                                    </div>

                                </div>
                                <div className={createSubModelMode ? "search-input-btn" : "hide"}
                                    onClick={(e: any) => onCreateSubModelClick(e)}
                                >ליצור {vehicleSubModelText}?</div>

                                <div className={updateSubModelMode ? "search-input-btn" : "hide"}
                                    onClick={(e: any) => onUpdateSubModelClick(e)}
                                >עדכן {vehicleSubModelText}?</div>
                                <div className={submodelErr ? "error-message" : "hide"}>חסר נתוני דגם</div>
                            </div>


                            <div className="search-input">
                                <div className="label">
                                    קוד דגם
                                </div>
                                <div className="filter-input">
                                    <input type='text'
                                        onChange={(e: any) => onModelCodeChange(e)}
                                        value={modelCode != null ? modelCode : ""}
                                    />
                                    <div className={`icon x-clear pointer ${!modelCode ? 'hide' : ''}`} onClick={() => clearValue('modelCode')}></div>
                                </div>
                            </div>


                        </div>


                        <div className="filter-row flex-centered flex-space-between">
                            <div className={loadGovData ? "hide" : "govData"} >

                                <div className={loadGovData ? "hide" : "btn"}
                                    onClick={(e: any) => ShowGovDetails()}
                                >טען ממשרד התחבורה</div>
                            </div>
                            <div className={loadGovData ? "" : "hide"}>
                                <div className="search-input">
                                    <div className="label">
                                        קוד משרד התחבורה
                                    </div>
                                    <div className="filter-input">
                                        <input type='text'
                                            onChange={(e: any) => setDegemCd(e.target.value)}
                                            value={degemCd != null ? degemCd : ""}
                                        />

                                        -
                                        <input type='text'
                                            onChange={(e: any) => setTozeretCd(e.target.value)}
                                            value={tozeretCd != null ? tozeretCd : ""}
                                        />
                                    </div>
                                    <div className={showIcon ? "" : "hide"} onClick={(e: any) => iconClick()}><FontAwesomeIcon icon={faCircleInfo} /> </div>
                                    <div className={showImg ? "" : "hide"} onClick={(e: any) => imgClick()}><img src={exampleIcon} width="800px" /></div>
                                </div>


                                <div className="search-input">
                                    <div className="btn" onClick={(e: any) => GetGovDetails()}>
                                        טען
                                    </div>
                                </div>
                            </div>
                            <div className={govError ? "error-message" : "hide"}>לא אותרו נתונים במשרד התחבורה</div>
                        </div>



                        <div className="filter-row flex-centered flex-space-between">
                            <div className='search-input-div'>
                                <div className="cell connectVehicle  " onClick={(e: any) => GetVehicleSubmodelId()}>קשר רכב </div>

                            </div>
                        </div>
                    </div>

                </div>
            </section>
        </div>

    );
};

export default VehicleDetails;
